import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AdvanceSearchService } from '../../services/Advance-search/advance-search.service';

@Component({
  selector: 'app-occupancy-statistics',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './occupancy-statistics.component.html',
  styleUrl: './occupancy-statistics.component.scss',
})
export class OccupancyStatisticsComponent {
  occupancyDate = new FormControl('');

  regularData: any[] = [];
  utsavData: any[] = [];
  grandTotal: any = null;

  constructor(private advanceService: AdvanceSearchService) {}

  searchOccupancy(): void {
    if (!this.occupancyDate.value) return;

    this.advanceService
      .getOccupancyStats(this.occupancyDate.value)
      .subscribe({
        next: (res: any) => {
          const occupancy = res?.data?.occupancy || [];

          this.regularData = occupancy.filter(
            (item: any) => item.category === 'Regular'
          );

          this.utsavData = occupancy.filter(
            (item: any) => item.category === 'Utsav'
          );

          this.grandTotal = res?.data?.grandTotal || null;
        },
        error: (err) => {
          console.error(err);

          this.regularData = [];
          this.utsavData = [];
          this.grandTotal = null;
        },
      });
  }

  reset(): void {
    this.occupancyDate.setValue('');

    this.regularData = [];
    this.utsavData = [];
    this.grandTotal = null;
  }
}